var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_485)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.806885,
    width: 33,
    height: 33,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2538 9.0564C19.2901 9.0564 19.3256 9.05946 19.3603 9.06534L19.4742 9.06601C19.6462 9.06601 19.8106 9.13599 19.9304 9.25994L24.202 13.7095C24.3141 13.8267 24.3775 13.9844 24.3775 14.1471V21.8961C24.3909 24.0117 22.7416 25.731 20.6226 25.8069H13.759C11.7014 25.7627 10.0512 24.1 10.0003 22.0633L10 12.8427C10.0497 10.7507 11.7766 9.06601 13.8526 9.06601L19.1473 9.06534C19.1819 9.05946 19.2175 9.0564 19.2538 9.0564ZM18.6209 10.3305L13.8551 10.3308C12.4579 10.3308 11.2977 11.4624 11.2648 12.8579V21.8961C11.2344 23.3304 12.3643 24.5109 13.7851 24.5421H20.6007C22.008 24.4915 23.1219 23.3304 23.1126 21.9003L23.1126 14.9445L21.4191 14.9453C19.8752 14.9411 18.6214 13.683 18.6214 12.1417L18.6209 10.3305ZM16.864 15.0928C17.0385 15.0928 17.1966 15.1636 17.3111 15.2781L17.312 15.2786L19.2901 17.2652C19.5363 17.5131 19.5355 17.9128 19.2884 18.159C19.0405 18.4052 18.64 18.4052 18.3938 18.1573L17.496 17.2557L17.4964 20.8189C17.4964 21.168 17.2131 21.4513 16.864 21.4513C16.5149 21.4513 16.2316 21.168 16.2316 20.8189L16.2312 17.2557L15.3347 18.1573C15.2116 18.2821 15.0488 18.3436 14.8869 18.3436C14.7259 18.3436 14.564 18.2821 14.4409 18.159C14.1938 17.9128 14.1921 17.5131 14.4392 17.2652L16.4156 15.2786L16.4439 15.2526C16.4561 15.2418 16.4687 15.2314 16.4817 15.2215L16.4156 15.2786C16.4392 15.255 16.4645 15.2337 16.4912 15.2148C16.5954 15.1381 16.7244 15.0928 16.864 15.0928ZM19.8857 11.0396L19.8862 12.1417C19.8862 12.9882 20.5742 13.678 21.4208 13.6805L22.4195 13.6797L19.8857 11.0396Z",
    fill: "#78A22F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_485"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.806885,
    width: 33,
    height: 33,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.89f28a9f2894fc8557cdd65c15a7143a.svg";
export { ForwardRef as ReactComponent };